const customRender = (text, record, index) => {
  if (text !== "undefined") {
    if (text === 0) {
      return "文件";
    } else if (text === 1) {
      return "数据库";
    } else if (text === 2) {
      return "OSS";
    } else if (text === 3) {
      return "FDHS";
    }
  }
  return "目录";
};

const setColumns = (_this) => {
  return [
    {
      title: "ID",
      align: "left",
      dataIndex: "id",
      width: 160,
      customCell: function(record) {
        record.style = { overflow: "hidden" };
        return record;
      },
      customRender: function(v) {
        return remId(v);
      }
    },
    {
      title: "名称",
      align: "left",
      dataIndex: "name",
      scopedSlots: { customRender: "nameItem" },
      customHeaderCell: function(record) {
        record.style = { paddingLeft: "20px" };
        return record;
      }
    },
    {
      title: "文件类型",
      align: "center",
      dataIndex: "type",
      width: 80
    },

    {
      title: "文件大小",
      dataIndex: "size",
      align: "center",
      width: 80
    },
    {
      title: "储存方式",
      width: 80,
      dataIndex: "storageType",
      align: "center",
      customRender: customRender,
      width: 80
    },
    {
      title: "创建时间",
      align: "left",
      width: 160,
      dataIndex: "createTime"
    },
    {
      title: "储存地址",
      dataIndex: "path",
      customCell: function(record) {
        record.style = { overflow: "hidden" };
        return record;
      }
    }
  ];
};

const initPages = (pagesSize = 20) => {

  return {
    total: 0,
    //size: 'Pagination',
    defaultCurrent: 1,
    defaultPageSize: pagesSize,
    current: 1,
    pageSize: pagesSize,
    showQuickJumper: true,
      size: 'small',
    showTotal: function (total, range) {
      return "从" + range[0] + "至" + range[1] + ",共" + total + "条";
    },
    showSizeChanger: true,
    pageSizeOptions: [ "20",  "40", "60", "80", "100", "500"]
  };
};

// const initPages = () => {
//   return {
//     total: 0,
//     size: "Pagination",
//     defaultCurrent: 1,
//     defaultPageSize: 20,
//     current: 1,
//     pageSize: 20,
//     showQuickJumper: true,
//     size: "small",
//     showTotal: function(total, range) {
//       return "当前从" + range[0] + "至" + range[1] + ",共" + total + "条记录";
//     },
//     showSizeChanger: true,
//     pageSizeOptions: ["20", "40", "60", "80", "100", "500"]
//   };
// };
const setId = (id) => {
  // if (id.toString().indexOf("d") > -1 || id === 0) return id;
  // return "d" + id;
  return id;
};
const remId = (id) => {
  // if (!isNaN(id) || id === 0) return id;
  // return id.substr(1);
  return id;
};

const setFormItems = (id = 0, name = "") => {
  var checked = false;
  return [
    {
      el: "aInput",
      hidden: true,
      type: "number",
      decorator: [
        "id",
        {
          initialValue: id
        }
      ]
    },
    {
      el: "aInput",
      label: "添加新文件到当前目录",
      decorator: [
        "name",
        {
          rules: [
            {
              required: true,
              message: "文件名称不能为空"
            }
          ],
          initialValue: name
        }
      ],
      placeholder: "请输入文件名称"
    },
    {
      el: "aCheckbox",
      children: "是否设为父级跟目录",
      decorator: [
        "is",
        {
          valuePropName: "checked",
          initialValue: false
        }
      ]
    }
  ];
};

const updateFormItems = (_this) => {
  return [
    {
      el: "aInput",
      hidden: true,
      type: "number",
      decorator: [
        "directoryId",
        {
          initialValue: 0
        }
      ]
    },
    {
      el: "aUpload",
      label: "文件上传",
      fileList: _this.fileList,
      beforeUpload: _this.beforeUpload,
      remove: (arr) => (_this.fileList = []),
      multiple: false,
      decorator: [
        "file",
        {
          rules: [
            {
              required: true,
              message: "请上传文件"
            }
          ]
        }
      ]
    },
    {
      el: "aSelect",
      options: [
        { label: "文件", value: 0 },
        { label: "数据库", value: 1 },
        { label: "OSS", value: 2 },
        { label: "FDHS", value: 3 }
      ],
      label: "储存方式",
      decorator: [
        "storageType",
        {
          rules: [
            {
              required: true
            }
          ],
          initialValue: 0
        }
      ]
    }
  ];
};

export { customRender, updateFormItems, setFormItems, setColumns, initPages, setId, remId };
